const notice = [
    { value: "One week", label: "One week" },
    { value: "Two Weeks", label: "Two Weeks" },
    { value: "Three Weeks", label: "Three Weeks" },
    { value: "Four Weeks", label: "Four Weeks" },
  ];
  
  export default notice;
  